export default function Results() {
  const results = [
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'B2C товары из Китая',
      metric: '+55%',
      detail: 'конверсии в продажу',
      extra: '+116 000 $ валовой прибыли',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Israel Assist',
      metric: '64% → 84%',
      detail: 'продление клиентов',
      extra: 'Рост LTV и повторных продаж',
    },
    {
      icon: 'ri-building-line',
      title: 'Агентство недвижимости',
      metric: '×2',
      detail: 'рост договоров',
      extra: 'Система холодных звонков',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Аудит отдела продаж',
      metric: '+30%',
      detail: 'объём продаж',
      extra: 'После внедрения рекомендаций',
    },
  ];

  return (
    <section id="results" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Результаты <strong>корпоративного обучения продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждый проект — это измеримые цифры. Мы фиксируем исходные показатели до начала работы и отслеживаем динамику после.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-default">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4 flex-shrink-0">
                <i className={`${item.icon} text-xl text-teal-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-3">{item.title}</h3>
              <div className="text-3xl font-extrabold text-teal-600 mb-1">{item.metric}</div>
              <p className="text-sm text-gray-600 mb-3">{item.detail}</p>
              <div className="bg-teal-50 rounded-lg px-3 py-2 text-xs text-teal-700 font-medium">
                {item.extra}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}